import React from 'react';
import './addMsg.css'

const AddMsg = () => {
    return (
        <div className="alert-wrapper">
            <div className="alert custom-alert" role="alert">
                <span>Now select your store's location on the map</span>
            </div>
        </div>
    );
}

export default AddMsg;